/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PatchContractActionStatusV1Dto = {
  /**
   * The current version of the contract action
   */
  version: number;
  /**
   * status of the contract action
   */
  status: PatchContractActionStatusV1Dto.status;
};
export namespace PatchContractActionStatusV1Dto {
  /**
   * status of the contract action
   */
  export enum status {
    AVAILABLE = 'Available',
    UNAVAILABLE = 'Unavailable',
    ACTIVE = 'Active',
    COMPLETED = 'Completed',
    SKIP = 'Skip',
  }
}
